module.exports = __webpack_public_path__ + "img/Invasion-LICA_GSE236681.6dcb7faa.png";